/* eslint-disable dot-notation */
import axios from 'axios';
// const axiosInstance = axios.create();
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    "Authorization": "Basic YWNjZXNzbGluazphY2Nlc3NsaW5rMjEyMQ==",
    "Content-type": "application/json"
  }
});
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
    }
    return error.response
    // Promise.reject((error.response) || 'Something went wrong')
  }
);

export default axiosInstance;
